import React from 'react';
import { Box, Button, Flex, Icon, Text, VStack } from '@chakra-ui/react';
import { FiChevronRight, FiUserPlus } from 'react-icons/fi';
import UgcPieceIcon from './UgcPieceIcon';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

export type PitchType = 'ugc' | 'influencer';

interface PitchCollabSheetProps {
  isOpen: boolean;
  onClose: () => void;
  brandName: string;
  onSelect: (type: PitchType) => void;
}

const Option: React.FC<{ icon: React.ReactNode; title: string; description: string; onClick: () => void }> = ({
  icon,
  title,
  description,
  onClick,
}) => (
  <Flex
    as="button"
    type="button"
    onClick={onClick}
    w="100%"
    align="center"
    gap="14px"
    p={4}
    minH="76px"
    textAlign="left"
    bg="white"
    border="1px solid"
    borderColor={ff.line}
    borderRadius="20px"
    _hover={{ borderColor: ff.ink }}
    transition="border-color 0.15s"
  >
    {icon}
    <Box flex={1} minW={0}>
      <Text fontSize="15px" fontWeight="600" color={ff.ink}>{title}</Text>
      <Text fontSize="13px" color={ff.text2} mt={0.5} lineHeight="1.4">{description}</Text>
    </Box>
    <Icon as={FiChevronRight} color={ff.muted} boxSize="18px" />
  </Flex>
);

/** "Pitch a collab": the creator says up front whether they're pitching UGC or an influencer collab. */
const PitchCollabSheet: React.FC<PitchCollabSheetProps> = ({ isOpen, onClose, brandName, onSelect }) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    title="Pitch a collab"
    footer={
      <Button variant="inkOutline" w="100%" mt={5} onClick={onClose}>
        Cancel
      </Button>
    }
  >
    <Text fontSize="15px" color={ff.text2} lineHeight="1.45">What kind of collab are you pitching to {brandName}?</Text>
    <VStack spacing={3} mt={5}>
      <Option
        icon={<UgcPieceIcon type="video" size={44} />}
        title="UGC Collab"
        description="You create the content, they post it on their accounts"
        onClick={() => onSelect('ugc')}
      />
      <Option
        icon={
          <Flex w="44px" h="44px" borderRadius="14px" bg={ff.ink} align="center" justify="center" flexShrink={0}>
            <Icon as={FiUserPlus} color={ff.lime} boxSize="18px" />
          </Flex>
        }
        title="Influencer Collab"
        description="You post to your own Instagram or TikTok followers"
        onClick={() => onSelect('influencer')}
      />
    </VStack>
  </ModalShell>
);

export default PitchCollabSheet;
